/**
 * Single Event Page Scripts
 *
 * Only loaded on single event pages via functions.php
 *
 * @package Interact_26
 */

// Reusable scripts (also used on webinars/other pages)
import { initAgendaToggles } from './agenda';
import { initCountdown } from './countdown';
import { initSpeakerToggles } from './speakers';
import { initScrollToast } from '../resources/scripts/scroll-toast';
import { initSmoothScroll } from '../resources/scripts/smooth-scroll';
import { initStickyCta } from '../resources/scripts/sticky-cta';

const onDocumentReady = (callback: () => void): void => {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
};

onDocumentReady(() => {
  // Reusable
  initAgendaToggles();
  initSpeakerToggles();
  initSmoothScroll();

  // Event-only
  initCountdown();
  initStickyCta();
  initScrollToast();
});
